var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 19H19M1 19H2.67454C3.16372 19 3.40832 19 3.63849 18.9447C3.84256 18.8957 4.03765 18.8149 4.2166 18.7053C4.41843 18.5816 4.59138 18.4086 4.93729 18.0627L17.5 5.49998C18.3285 4.67156 18.3285 3.32841 17.5 2.49998C16.6716 1.67156 15.3285 1.67156 14.5 2.49998L1.93726 15.0627C1.59136 15.4086 1.4184 15.5816 1.29472 15.7834C1.18506 15.9624 1.10425 16.1574 1.05526 16.3615C1 16.5917 1 16.8363 1 17.3255V19Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublications);
export default __webpack_public_path__ + "static/media/icon-publications.b4f583b1c03dafa03af707e42ef2a64d.svg";
export { ForwardRef as ReactComponent };